import React from "react";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import "./VideoGallery.css";

const videos = [
  {
    id: 1,
    title:
      "TEDx talk video | What Comes Next is Yours to Write | Mouna Nanaiah | TEDx Siddaganga Instituteof Technology",
    youtubeId: "UKNOlOm8UkA",
  },

  {
    id: 2,
    title:
      "Decathlon podcast | Hiking & Trekking 101 - Budget Travel, Preparing for Himalayas, Solo Travel with @Indiahikes",
    youtubeId: "RZUjeU9qa_I",
  },

  {
    id: 3,
    title:
      "Decathlon podcast | Motorcycling to the Mountains - Tips and Mistakes to Avoid with @CandidalouisIndia",
    youtubeId: "X4ST8txDGHY",
  },

  {
    id: 4,
    title:
      "Takes 2 to Tango ft @mounananaiah",
    youtubeId: "wXbA_brGMHQ",
  },

  {
    id: 4,
    title:
      "OAPN with Adarsh Sakare || Episode 69 || Mouna Nanaiah",
    youtubeId: "EAeOVZgL0w8",
  },
  
];

const responsive = {

  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
    slidesToSlide: 1,
  },

  tablet: {
    breakpoint: { max: 1024, min: 768 },
    items: 1,
  },

  mobile: {
    breakpoint: { max: 768, min: 0 },
    items: 1,
  },

};

const VideoGallery = () => {

  return (

    <div className="video-gallery-main">

      {/* HEADING */}

      <div className="video-gallery-heading">

        <p className="video-subtitle">
          
          A glimpse into the stories, ideas and voices we share
        </p>

        <h2 className="video-title-main">
          Featured Talks & Podcasts
        </h2>

      </div>

      {/* CAROUSEL */}

      <Carousel
        responsive={responsive}
        infinite={true}
        autoPlay={false}
        arrows={true}
        draggable={true}
        swipeable={true}
        showDots={false}
        containerClass="carousel-container"
        itemClass="carousel-item-padding-40-px"
      >

        {videos.map((video) => (

          <div
            className="video-card-new"
            key={video.id}
          >

            <div className="player-wrapper">

              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${video.youtubeId}`}
                title={video.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>

            </div>

            <h3 className="video-card-title">
              {video.title}
            </h3>

          </div>

        ))}

      </Carousel>

    </div>

  );
};

export default VideoGallery;